/**
 * Dienstleister-Logos — Anbieter, auf die FuelX u. a. zugreift.
 * Lokale PNG-Assets unter /public/logos/ (Wikimedia Commons / Brand-Icons).
 * Struktur je Provider: { name, logo }
 */

const T = {
  // TÜV/HU-Prüfstellen
  tuev:      { name: 'TÜV',          logo: '/logos/tuev-96.webp', benefit: 'TÜV/HU über FuelX Hotels: bis 160 € zurück', travel: true },
  dekra:     { name: 'DEKRA',        logo: '/logos/dekra-96.webp', benefit: 'HU, Gutachten & Gebrauchtwagen-Check: bis 160 € zurück', travel: true },
  kues:      { name: 'KÜS',          logo: '/logos/kues-96.webp', benefit: 'HU/AU-Prüfung: bis 160 € auf deine Prepaid Card', travel: true },
  gtue:      { name: 'GTÜ',          logo: '/logos/gtue-96.webp', benefit: 'HU/AU-Prüfung: bis 160 € auf deine Prepaid Card', travel: true },

  // Werkstattnetze
  atu:       { name: 'A.T.U',        logo: '/logos/atu-96.webp', benefit: 'Werkstatt & Reparaturen: bis 500 € gutschreibbar', travel: true },
  bosch:     { name: 'Bosch',        logo: '/logos/bosch-96.webp', benefit: 'Werkstatt-Netzwerk: Reparaturen bis 500 € gutschreibbar', travel: true },
  vergoelst: { name: 'Vergölst',     logo: '/logos/vergoelst-96.webp', benefit: 'Reifenwechsel: bis 250 € auf deine Prepaid Card', travel: true },

  // Kfz-Versicherer
  huk:       { name: 'HUK-COBURG',   logo: '/logos/huk-96.webp', benefit: 'Kfz-Versicherung: bis 750 € Beitrag pro Jahr zurück', travel: true },
  allianz:   { name: 'Allianz',      logo: '/logos/allianz-96.webp', benefit: 'Kfz-Versicherung: bis 750 € Beitrag pro Jahr zurück', travel: true },
  rplus:     { name: 'R+V',          logo: '/logos/rplus-96.webp', benefit: 'Kfz-Versicherung: bis 750 € Beitrag pro Jahr zurück', travel: true },
  ergo:      { name: 'ERGO',         logo: '/logos/ergo-96.webp', benefit: 'Kfz-Versicherung kostenlos prüfen lassen' },

  // Automobilclubs
  adac:      { name: 'ADAC',         logo: '/logos/adac-96.webp', benefit: 'Pannenhilfe im Netzwerk inklusive' },
  ace:       { name: 'ACE',          logo: '/logos/ace-96.webp', benefit: 'Pannenhilfe im Netzwerk inklusive' },
  avd:       { name: 'AvD',          logo: '/logos/avd-96.webp', benefit: 'Pannenhilfe im Netzwerk inklusive' },

  // Autokredite/Banken
  santander: { name: 'Santander',    logo: '/logos/santander-96.webp', benefit: 'Autokredit-Check: bessere Zinsen inklusive' },
  ing:       { name: 'ING',          logo: '/logos/ing-96.webp', benefit: 'Autokredit kostenlos prüfen lassen' },
  auxmoney:  { name: 'auxmoney',     logo: '/logos/auxmoney-96.webp', benefit: 'Finanzierungs-Check inklusive im FuelX-Account' },
  vwbank:    { name: 'VW Bank',      logo: '/logos/vwbank-96.webp', benefit: 'Fahrzeugfinanzierung: Zins-Check inklusive' },

  // Autoglas
  carglass:  { name: 'Carglass',     logo: '/logos/carglass-96.webp', benefit: 'Glasreparatur: bis 500 € abgedeckt', travel: true },
  junited:   { name: 'junited',      logo: '/logos/junited-96.webp', benefit: 'Glasreparatur: bis 500 € abgedeckt', travel: true },
  wintec:    { name: 'Wintec',       logo: '/logos/wintec-96.webp', benefit: 'Glas- & Dellenreparatur: bis 500 € abgedeckt', travel: true },

  // Autoverkauf/Bewertung
  wirkaufen: { name: 'wirkaufendeinauto.de', logo: '/logos/wirkaufen-96.webp', benefit: 'Concierge-Autoverkauf: 499 € statt 1.199 €' },
  mobilede:  { name: 'mobile.de',    logo: '/logos/mobilede-96.webp', benefit: 'Autoverkauf zum Bestpreis — Concierge inklusive' },
  autoscout: { name: 'AutoScout24',  logo: '/logos/autoscout-96.webp', benefit: 'Autoverkauf zum Bestpreis — Concierge inklusive' },
  dat:       { name: 'DAT',          logo: '/logos/dat-96.webp', benefit: 'Fahrzeugbewertung & Wertgutachten: bis 190 € zurück', travel: true },

  // Reifen
  continental: { name: 'Continental', logo: '/logos/continental-96.webp', benefit: 'Reifenwechsel: bis 250 € auf deine Prepaid Card', travel: true },
  reifende:  { name: 'Reifen.de',    logo: '/logos/reifende-96.webp', benefit: 'Reifen & Wechsel: bis 250 € zurück', travel: true },

  // Hotels/Reisen
  booking:   { name: 'Booking.com',  logo: '/logos/booking-96.webp', benefit: 'Hotel-Bestpreis: 1,6 Mio Hotels weltweit' },
  expedia:   { name: 'Expedia',      logo: '/logos/expedia-96.webp', benefit: 'Hotel-Bestpreis: 1,6 Mio Hotels weltweit' },
  hrs:       { name: 'HRS',          logo: '/logos/hrs-96.webp', benefit: 'Geschäftsreisen & Hotels zum Bestpreis' },

  // Fahrzeughistorie
  carvertical: { name: 'carVertical', logo: '/logos/carvertical-v2.svg', benefit: 'Fahrzeughistorien-Report: 3 Checks pro Jahr kostenlos' },

  // FuelX selbst — Leistungen, um die wir uns direkt kümmern
  fuelx:     { name: 'FuelX', logo: '/fuelx-logo-final-cropped.png', benefit: 'Direkt von FuelX — wir kümmern uns.' },
};

/**
 * Mapping: USP-Slug → Top 3 Dienstleister (in Priorität-Reihenfolge)
 * Deckt Private + Business Slugs ab.
 */
// Tankstellen-Marken — nur für den Tankrabatt-USP (nicht Teil des Dienstleister-Marquees)
const FB = {
  shell: { name: 'Shell', logo: '/img/brands/shell.svg', benefit: 'Markenunabhängig tanken — Guthaben gilt u. a. bei Shell', brand: true },
  aral:  { name: 'Aral',  logo: '/img/brands/aral.svg',  benefit: 'Markenunabhängig tanken — Guthaben gilt u. a. bei Aral', brand: true },
  bp:    { name: 'BP',    logo: '/img/brands/bp.svg',    benefit: 'Markenunabhängig tanken — Guthaben gilt u. a. bei BP', brand: true },
};

// FuelX Hotels — Buchungen laufen direkt über FuelX Hotels, keine Dienstleister
const FXH = { name: 'FuelX Hotels', logo: '/fuelx-hotels-logo-96.webp', benefit: 'Buchung & Bestpreis direkt über FuelX Hotels' };

export const USP_PROVIDERS = {
  // ── PRIVATE ─────────────────────────────────────────────
  'tankrabatt':                       [FB.shell, FB.aral, FB.bp],
  'fehlerdiagnose':                   [T.bosch, T.atu],
  'schadenfoto-check':                [T.fuelx],
  'pannen-soforthilfe':               [T.fuelx],
  'autokosten-check':                 [T.fuelx],
  'fahrzeugordner':                   [T.fuelx],
  'unfall-assistent':                 [T.fuelx],
  'gebrauchtwagen-historiencheck':    [T.fuelx],
  // Digitale Services (Fahrzeug-Assistent & Co.) — direkt von FuelX
  'service-erinnerungen':             [T.fuelx],
  'wartungsplan':                     [T.fuelx],
  'saisonmanager':                    [T.fuelx],
  'rueckruf-check':                   [T.fuelx],
  'angebotscheck':                    [T.fuelx],
  'rechnungscheck':                   [T.fuelx],
  'wert-verlauf':                     [T.fuelx],
  'fristenwaechter':                  [T.fuelx],
  'unterlagencheck':                  [T.fuelx],
  'leasing-planer':                   [T.fuelx],
  'reparaturkosten-check':            [T.fuelx],
  'kasko-selbstbehalt':               [T.huk, T.allianz, T.adac],
  'kfz-versicherung-optimieren':      [T.huk, T.allianz, T.rplus],
  'autokredit-optimieren':            [T.santander, T.ing, T.vwbank],
  'auto-verkaufen-service':           [T.wirkaufen, T.mobilede, T.autoscout],
  'fahrzeugbewertung':                [T.fuelx],
  'hotels-16-mio':                    [FXH],
  'kfz-versicherung-zurueck':         [T.huk, T.allianz, T.rplus],
  'tuev-hu-zurueck':                  [T.tuev, T.dekra, T.kues],
  'pannenhilfe-zurueck':              [T.adac, T.ace, T.avd],
  'oelwechsel-zurueck':               [T.atu, T.bosch, T.vergoelst],
  'reifenwechsel-zurueck':            [T.vergoelst, T.reifende, T.atu],
  // Fahrzeugaufbereitung: FuelX kümmert sich direkt
  'fahrzeugaufbereitung-zurueck':     [T.fuelx],
  'gebrauchtwagen-check':             [T.dekra, T.tuev, T.gtue],
  'wertgutachten-zurueck':            [T.dat, T.tuev, T.dekra],
  'dellenreparatur-zurueck':          [T.wintec, T.atu],
  'glasreparatur-zurueck':            [T.carglass, T.junited, T.wintec],
  'leasing-rueckgabe':                [T.dat, T.dekra, T.tuev],

  // ── BUSINESS ────────────────────────────────────────────
  'fehlerdiagnose-flotte':            [T.bosch, T.atu],
  'transparente-reparaturkosten':     [T.atu, T.bosch, T.vergoelst],
  'kfz-versicherung-flotte':          [T.huk, T.allianz, T.rplus],
  'fahrzeugfinanzierungen':           [T.santander, T.ing, T.vwbank],
  'mitarbeiter-reisevorteile':        [T.expedia, T.hrs],
  'geschaeftsreisen-hotels':          [T.expedia, T.hrs],
  'firmenfahrzeuge-verkaufen':        [T.wirkaufen, T.mobilede, T.autoscout],
  'fahrzeugbewertung-flotte':         [T.dat, T.dekra, T.tuev],
  'kfz-versicherungsbeitrag':         [T.huk, T.allianz, T.rplus],
  'tuev-hu':                          [T.tuev, T.dekra, T.kues],
  'pannenhilfe':                      [T.adac, T.ace, T.avd],
  // Kfz-Steuer: FuelX kümmert sich direkt um die Abwicklung des Vorteils
  'kfz-steuer':                       [T.fuelx],
  'oelwechsel':                       [T.atu, T.bosch, T.vergoelst],
  'reifenwechsel':                    [T.vergoelst, T.continental, T.atu],
  'fahrzeugaufbereitung':             [T.fuelx],
  'wertgutachten':                    [T.dat, T.tuev, T.dekra],
  'dellenreparatur':                  [T.wintec, T.atu],
  'glasreparatur':                    [T.carglass, T.junited, T.wintec],
  'zentrale-kostenkontrolle':         [], // eher Prozess-USP, keine Dienstleister nötig
};

/**
 * Mapping: Service-Seiten (serviceKey) → passende Dienstleister
 */
export const SERVICE_PROVIDERS = {
  'tuev':           [T.tuev, T.dekra, T.kues, T.gtue],
  'werkstatt':      [T.bosch, T.atu, T.vergoelst, T.carglass],
  'oel-service':    [T.atu, T.bosch, T.vergoelst],
  'reifen-wechsel': [T.vergoelst, T.continental, T.reifende, T.atu],
  'autokredit':     [T.santander, T.ing, T.vwbank, T.auxmoney],
  'kfz-steuer':     [T.fuelx],
  'pannenhilfe':    [T.adac, T.ace, T.avd],
  'auto-verkaufen': [T.wirkaufen, T.mobilede, T.autoscout, T.dat],
  'versicherung':   [T.huk, T.allianz, T.rplus, T.ergo],
};

/**
 * Alle einzigartigen Dienstleister (für Homepage-Logo-Marquee)
 */
export const ALL_PROVIDERS = Object.values(T);

/** True, wenn FuelX diese Leistung selbst erbringt (keine Fremd-Logos, eigene Überschrift) */
export const isFuelXDirect = (slugOrList) => {
  const list = Array.isArray(slugOrList) ? slugOrList : USP_PROVIDERS[slugOrList] || [];
  return list.length > 0 && list.every((p) => p.name.startsWith('FuelX'));
};
